export const UPDATE_IMAGES = 'UPDATE_IMAGES';

export const updateImages = (payload: string[]) => ({
    type: UPDATE_IMAGES,
    payload,
});

export default (state = [] as string[], action: ReturnType<typeof updateImages>) =>
    action.type === UPDATE_IMAGES ? action.payload : state;
